import { addAjaxEpic, getSuccessActionType } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { getSignedInUserUrl } from '../../../redux/modules/accountApis';
import { AccountActions, IAccountAction, IAccountState } from '../../models';
import { IUserPerson } from '../../models/IUserPerson';
import { accountRegistry as registry } from '../accountRegistry';

export const getUserAjax = (ajax: IAjaxCreationMethod) => {
  return ajax.getJSON<IUserPerson>(getSignedInUserUrl());
};

export const getUserSuccess = (state: IAccountState, action: IAccountAction<IUserPerson>): IAccountState => {
  if (action.payload === undefined) {
    return state;
  }

  let nextState: IAccountState = {
    ...state,
    currentUser: action.payload
  };

  return nextState;
};

addAjaxEpic(registry, AccountActions.getUser, getUserAjax);
registry.add(getSuccessActionType(AccountActions.getUser), getUserSuccess);
